import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public currentUser: any = JSON.parse(localStorage.getItem('currentUser') ?? 'null') ?? {};

  public permisos: any = JSON.parse(localStorage.getItem('permisos') ?? 'null') ?? {};


  getCurrentUser() {
    return this.currentUser;
  }

  getPermisos() {
    return this.permisos;
  }

  clearSessionData() {
    this.currentUser = {};
    this.permisos = {};
    localStorage.removeItem('currentUser');
    localStorage.removeItem('permisos');
  }
}
